import {createSelector} from 'reselect';
import {getCombinedData} from '../../utils/statsUtils';

// Getters for full data sets
const getUseQuestions = (state) => state.dsaConfig && state.dsaConfig.useQuestions || [];
const getUseQuestionAnswers = (state) => state.dsa && state.dsa.dsaUseQuestions || [];
const getValueRealized = (state) => state.dsaConfig && state.dsaConfig.valueRealized || [];
const getValueRealizedAnswers = (state) => state.dsa && state.dsa.dsaValueRealized || [];

// Getters for area data sets
const getArea = (state, props) => props && props.area;
const getSubAreaIds = (state, props) => {
  return state.dsaConfig && props.area && state.dsaConfig.subAreas && state.dsaConfig.subAreas.filter(subarea => subarea.area === props.area.id).map((s) => s.id) || [];
};
// Getters for subarea data sets
const getSubArea = (state, props) => props && props.subarea;

export const makeGetAreaUsageProgress = () => {
  return createSelector(
    [getArea, getSubAreaIds, getUseQuestions, getUseQuestionAnswers, getValueRealized, getValueRealizedAnswers],
    (area, subAreaIds, questions, answers, valueQuestions, valueAnswers) => {
      let progress = {
        current: 0,
        total: subAreaIds.length * 2
      };

      let combinedUseQuestions = getCombinedData(questions, answers, 'usequestion');
      let combinedValueRealized = getCombinedData(valueQuestions, valueAnswers, 'valuerealized');

      subAreaIds.forEach(subAreaId => {
        let subAreaUseQuestions = combinedUseQuestions.filter(q => q.subarea === subAreaId);
        let answeredSubAreaUseQuestions = subAreaUseQuestions.filter(q => q.answer !== null);
        if (answeredSubAreaUseQuestions.length === subAreaUseQuestions.length) progress.current += 1;

        let subAreaValueRealized = combinedValueRealized.filter(q => q.subarea === subAreaId);
        let answeredSubAreaValueRealized = subAreaValueRealized.filter(q => q.answer !== null);
        if (answeredSubAreaValueRealized.length === subAreaValueRealized.length) progress.current += 1;
      });

      return progress;
    }
  );
};

export const makeGetSubAreaUsageProgress = () => {
  return createSelector(
    [getArea, getSubArea, getUseQuestions, getUseQuestionAnswers, getValueRealized, getValueRealizedAnswers],
    (area, subArea, questions, answers, valueQuestions, valueAnswers) => {
      let progress = {
        current: 0,
        total: 0
      };

      let combinedUseQuestions = getCombinedData(questions, answers, 'usequestion');

      let subAreaUseQuestions = combinedUseQuestions.filter(q => q.subarea === subArea.id);
      let answeredSubAreaUseQuestions = subAreaUseQuestions.filter(q => q.answer !== null);

      progress.total += subAreaUseQuestions.length;
      progress.current += answeredSubAreaUseQuestions.length;


      let combinedValueRealized = getCombinedData(valueQuestions, valueAnswers, 'valuerealized');

      let subAreaValueRealized = combinedValueRealized.filter(q => q.subarea === subArea.id);
      let answeredSubAreaValueRealized = subAreaValueRealized.filter(q => q.answer !== null);

      progress.total += subAreaValueRealized.length;
      progress.current += answeredSubAreaValueRealized.length;

      return progress;
    }
  );
};



// WEBPACK FOOTER //
// ./src/selectors/dsa/usageSelectors.js